module.exports = __webpack_public_path__ + "static/media/ic_product_robotrader_info_one.a5451ca2.svg";